<template>
    <div class="ma-0 pa-0">

        <v-list :dense="dense">
            <v-list-item v-for="(item, i) in getVisibleItems()" :key="i">

                <v-list-item-content>
                    <v-list-item-title>
                            <div>
                                <span class="px-0">
                                    <template v-for="n in getItemLevel(item)-1" ><span :key="n"/>&#12288;&#12288;</template>
                                </span>
                                <span class="mx-2">
                                    <v-icon v-if="canOpen(item)" v-on:click="openItem(item)">mdi-plus-box-outline</v-icon>
                                    <v-icon v-else-if="canClose(item)"  v-on:click="closeItem(item)">mdi-minus-box-outline</v-icon>
                                    <v-icon v-else>mdi-border-none-variant</v-icon>
                                </span>
                                <span>
                                    <v-icon v-if="getItemSelectState(item)==1" v-on:click.stop.prevent="tryUnSelect(item)">mdi-checkbox-marked</v-icon>
                                    <v-icon v-else-if="getItemSelectState(item)==-1" v-on:click.stop.prevent="trySelect(item)">mdi-checkbox-blank-outline</v-icon>
                                    <v-icon v-else v-on:click.stop.prevent="trySelect(item)">mdi-checkbox-intermediate</v-icon>			
                                </span>
                                <span class="ml-2">
                                    {{getItemText(item)}}
                                </span>
                                
                            </div>
                    </v-list-item-title>
                </v-list-item-content>
                
            </v-list-item>
      </v-list>

    </div>
</template>

<script>

import TreeSelectorModel from './TreeSelectorModel.js';

export default {
    name: 'Tree-Selector',
    props:{

        value : {
            type:Array,
            default:[],
        },
        items:{
            type:Array,
            default:[],
        },
        itemText:{
            type:String,
            default:'name',
        },
        itemKey:{
            type:String,
            default:'id',
        },
        itemChildren:{
            type:String,
            default:'children',
        },
        outlined:{
            type:Boolean,
            default:false,
        },
        dense:{
            type:Boolean,
            default:false,
        },
        menuMaxHeight:{
            type:String,
            default:'400',
        },
        multiSelect:{
            type:Boolean,
            default:false,
        },
        selectionType:{
            //1 单选 2联动
            type:String,
            default:'1',
        },
        selectionCheck:{
            type:Function,
            default:function(){return true;},
        }
    },
    model:{
        prop:'value',
        event:'change',
    },
    components: {
    },
    data () {
        return {
            itemMap:new Map(),
            treeSelectorModel:new TreeSelectorModel(),
        }
    },
    
    methods:{
        getVisibleItems(){
            let visible = this.treeSelectorModel.getVisible();
            return visible; 
        },

        
        canOpen(item){
            return this.treeSelectorModel.canOpen(item);
        },
        canClose(item){
            return this.treeSelectorModel.canClose(item);
        },
        openItem(item){
            this.treeSelectorModel.open(item);
        },
        closeItem(item){
            this.treeSelectorModel.close(item);
        },  
        getItemText(item){
            return item[this.itemText];
        },
        getItemSelectState(item){
            return this.treeSelectorModel.getItemSelectState(item);
        },
        getItemLevel(item){
            return this.treeSelectorModel.getItemLevel(item);
        },
       
        initSelectedValue(){
            let me = this;
            if(this.value ){
                this.treeSelectorModel.setSelected(this.value);
            }else{
                this.treeSelectorModel.setSelected([]); 
            }
        },

        trySelect(item){
            if(this.selectionCheck){
                if(this.selectionCheck(item)){
                    this.treeSelectorModel.doSelect(item,true);
                    this.dispatchInputChange();
                }
            }

        },
        tryUnSelect(item){
            this.treeSelectorModel.doUnSelect(item,true);
            this.dispatchInputChange();
        },

        dispatchInputChange(){
            let me =this;
            console.log("开始派发change");
            let selectedItem = this.treeSelectorModel.getSelectedItems();
            let selectedValue = [];
            selectedItem.forEach(function(item){
                selectedValue.push(item[me.itemKey]);
            });
            
            this.$emit('change', selectedValue)
        },
        //如果是单选，不能启动连带选择
        getSelectionType(){
            if(!this.multiSelect){
                return 1;
            }
            return this.selectionType;
        }

    },
    mounted(){
    },
    created(){
        this.treeSelectorModel.setItemOption(this.itemKey,this.itemText,this.itemChildren);
        this.treeSelectorModel.setSelectionType(this.selectionType);
        this.treeSelectorModel.setSelectionCheck(this.selectionCheck);
        this.treeSelectorModel.setMultiSelect(this.multiSelect);

        this.treeSelectorModel.setItems(this.items);
        this.initSelectedValue();
    },
    watch: {
        value:function(val){
            this.initSelectedValue();
        },
        items:function(val){
            this.treeSelectorModel.setItems(this.items);
        }
    }, 
    computed:{

    }
}
</script>
<style scoped>


</style>
